import { render, staticRenderFns } from "./LoginVerification.vue?vue&type=template&id=6bcc7350&scoped=true"
import script from "./LoginVerification.vue?vue&type=script&lang=js"
export * from "./LoginVerification.vue?vue&type=script&lang=js"
import style0 from "./LoginVerification.vue?vue&type=style&index=0&id=6bcc7350&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcc7350",
  null
  
)

export default component.exports